import { ReactNode } from 'react';
import { isValidPassword, isNonEmpty } from '../../helpers/validators';
import authCopy from '../authCopy';

const { errors } = authCopy;

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export function validatePassword(password: any): ReactNode {
    if (!isNonEmpty(password)) {
        return errors.passwordRequired;
    } else if (!isValidPassword(password)) {
        return errors.passwordShort;
    }
    return null;
}
